/**
 * ContentMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the content mask.
 */
interface Props {
  miniDetailFocused: boolean;
}

/**
 * Content mask (dark fade).
 */
const ContentMask = styled.div<Props>`
  background: ${(props) =>
    props.miniDetailFocused
      ? 'linear-gradient(252deg, rgba(0, 0, 0, 0.00) 37.88%, #000 50.69%, #010101 71.22%, #010101 73.12%, #010101 80.52%)'
      : 'linear-gradient(179deg, rgba(0, 0, 0, 0) 42.28%, #000 64.26%)'};
  bottom: 0;
  height: ${1080 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(ContentMask);
